import * as React from 'react';

export function SvgMicrosoftExcel(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14_237)">
        <path
          d="M14.5581 11.55L6.65112 10.2V20.1752C6.65112 20.6307 7.03282 21 7.50368 21H21.1474C21.6183 21 22 20.6307 22 20.1752V16.5L14.5581 11.55Z"
          fill="#185C37"
        />
        <path
          d="M14.5581 3H7.50368C7.03282 3 6.65112 3.3693 6.65112 3.82485V7.5L14.5581 12L18.7441 13.35L22 12V7.5L14.5581 3Z"
          fill="#21A366"
        />
        <path d="M6.65112 7.5H14.5581V12H6.65112V7.5Z" fill="#107C41" />
        <path
          opacity="0.1"
          d="M12.3102 6.60001H6.65112V17.85H12.3102C12.7804 17.8485 13.1612 17.4801 13.1628 17.0252V7.42485C13.1612 6.96992 12.7804 6.60148 12.3102 6.60001Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M11.8451 7.04999H6.65112V18.3H11.8451C12.3153 18.2985 12.6961 17.9301 12.6976 17.4751V7.87484C12.6961 7.4199 12.3153 7.05147 11.8451 7.04999Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M11.8451 7.04999H6.65112V17.4H11.8451C12.3153 17.3985 12.6961 17.0301 12.6976 16.5751V7.87484C12.6961 7.4199 12.3153 7.05147 11.8451 7.04999Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M11.38 7.04999H6.65112V17.4H11.38C11.8502 17.3985 12.231 17.0301 12.2325 16.5751V7.87484C12.231 7.4199 11.8502 7.05147 11.38 7.04999Z"
          fill="black"
        />
        <path
          d="M2.85256 7.04999H11.38C11.8508 7.04999 12.2325 7.41928 12.2325 7.87484V16.1251C12.2325 16.5807 11.8508 16.95 11.38 16.95H2.85256C2.3817 16.95 2 16.5807 2 16.1251V7.87484C2 7.41928 2.3817 7.04999 2.85256 7.04999Z"
          fill="url(#paint0_linear_14_237)"
        />
        <path
          d="M4.6405 14.6811L6.43399 11.9924L4.79074 9.31845H6.11259L7.00934 11.0285C7.09213 11.1909 7.14887 11.3115 7.17958 11.3911H7.1912C7.25012 11.2615 7.31213 11.1357 7.37725 11.0136L8.33585 9.31936H9.54934L7.86422 11.9775L9.59214 14.6811H8.30097L7.26516 12.8042C7.21636 12.7243 7.17496 12.6404 7.14144 12.5535H7.12609C7.09575 12.6386 7.05549 12.7202 7.00609 12.7965L5.93958 14.6811H4.6405Z"
          fill="white"
        />
        <path
          d="M21.1474 3H14.5581V7.5H22V3.82485C22 3.3693 21.6183 3 21.1474 3Z"
          fill="#33C481"
        />
        <path d="M14.5581 12H22V16.5H14.5581V12Z" fill="#107C41" />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_14_237"
          x1="3.7776"
          y1="6.40547"
          x2="10.1295"
          y2="17.7763"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#18884F" />
          <stop offset="0.5" stopColor="#117E43" />
          <stop offset="1" stopColor="#0B6631" />
        </linearGradient>
        <clipPath id="clip0_14_237">
          <rect
            width="20"
            height="18"
            fill="white"
            transform="translate(2 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
